import type { Permission, PermissionDeviation } from '../entities/Permission';
import { PERMISSION_FIELDS } from '../entities/Permission';

export type PermissionFlagsRow = Pick<
  Permission,
  'featureId' | 'allowRead' | 'allowWrite' | 'allowDelete' | 'allowCentralAccess' | 'allowExcelExport'
>;

/** Compare effective permissions to role template; returns deviation entries for the matrix UI. */
export function computePermissionDeviations(permissions: Permission[], roleTemplate: Permission[]): PermissionDeviation[] {
  const templateMap = new Map(roleTemplate.map((t) => [t.featureId, t]));
  const deviations: PermissionDeviation[] = [];

  for (const p of permissions) {
    const t = templateMap.get(p.featureId);
    if (!t) continue;
    for (const f of PERMISSION_FIELDS) {
      if (p[f] !== t[f]) {
        deviations.push({
          featureId: p.featureId,
          featureName: p.featureName,
          category: p.category,
          field: f,
          direction: p[f] ? 'above' : 'below'
        });
      }
    }
  }

  return deviations;
}

/** Count mismatched permission flags between a user row and its role template row (same feature). */
export function countDeviationFieldsForTemplateRow(userRow: PermissionFlagsRow, templateRow: PermissionFlagsRow | undefined): number {
  if (!templateRow) return 0;
  let count = 0;
  for (const f of PERMISSION_FIELDS) {
    if (userRow[f] !== templateRow[f]) count++;
  }
  return count;
}
